__turbopack_context__.v({
  "actionsWrp": "startActions-module-scss-module__X-GJCq__actionsWrp",
  "bookDemoButton": "startActions-module-scss-module__X-GJCq__bookDemoButton",
  "buttonsDivider": "startActions-module-scss-module__X-GJCq__buttonsDivider",
  "getStartedButton": "startActions-module-scss-module__X-GJCq__getStartedButton",
});
